import { assetActionTypes } from '../../config/constant'
import { Action, Feature, Waypoint } from './types'

export interface Asset {
    name: string
    id: string
    latitude: string | number
    longitude: string | number
    velocity: string | number
    altitude: string | number
    tilt: string | number
    yaw: string | number
    pitch: string | number
    roll: string | number
    payload: string
    threat_level: string
    alliance: string
    type: string
    features: Feature[]
    waypoints: Waypoint[]
    model: string
    visible: string | boolean
}

export interface AssetsState {
    blueSelectedAsset: Asset
    detectedSelectedAsset: Asset
    detectedList: Asset[] | null
}

export const EmptyBlueAsset: Asset = {
    name: 'No UAV selected',
    id: '-',
    latitude: '-',
    longitude: '-',
    velocity: '-',
    altitude: '-',
    tilt: '-',
    yaw: '-',
    pitch: '-',
    roll: '-',
    payload: '-',
    threat_level: '-',
    alliance: '-',
    type: '-',
    features: [],
    waypoints: [],
    model: '-',
    visible: '-',
}

export const EmptyDetectedAsset: Asset = {
    ...EmptyBlueAsset,
    name: '',
}

const initialState: AssetsState = {
    blueSelectedAsset: EmptyBlueAsset,
    detectedSelectedAsset: EmptyDetectedAsset,
    detectedList: null,
}

export default function (state = initialState, action: Action) {
    switch (action.type) {
        case assetActionTypes.UPDATE_ASSET_SELECTION: {
            return { ...state, ...action.payload }
        }
        case assetActionTypes.RESET_ASSET_SELECTION: {
            return { ...state, ...action.payload }
        }
        case assetActionTypes.UPDATE_DETECTION_SELECTION: {
            return { ...state, ...action.payload }
        }
        case assetActionTypes.RESET_DETECTION_SELECTION: {
            return { ...state, ...action.payload }
        }
        case assetActionTypes.UPDATE_DETECTION_LIST: {
            return { ...state, ...action.payload }
        }
        case assetActionTypes.CLEAR_DETECTION_LIST: {
            return { ...state, ...action.payload }
        }
        default: {
            return state
        }
    }
}
